module.exports = __webpack_public_path__ + "935f8295c2d049bf6336b98b19c00616.pdf";